import { Table, Tooltip, Spin } from "antd";
import * as React from "react";
import { getAllCourseReview } from "../../Graphs/CourseReview/listAllReviews";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { checkPermission } from "../AdminUser/CheckAdminPermission";
import moment from "moment";
import { Rate } from "antd";

const NativeSelect = ({ value, onChange, children, className }) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className={className}
      style={{
        padding: "3px 8px",
        borderRadius: "4px",
        border: "1px solid #d9d9d9",
        backgroundColor: "#fff",
        outline: "none",
        cursor: "pointer",
        marginLeft: "8px",
        height: "28px"
      }}
    >
      {React.Children.map(children, (child) => {
        if (!child) return null;
        return <option value={child.props.value}>{child.props.children}</option>;
      })}
    </select>
  );
};

class CourseReviewRecordsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      startIndex: 0,
      limitNumber: 10,
      pagination: {
        pageSize: 10,
        current: 1,
      },
    };
    this.handleTableChange = this.handleTableChange.bind(this);
    this.getLimitedCourseReview = this.getLimitedCourseReview.bind(this);
  }

  async componentDidMount() {
    const { loginUserData } = this.props;

    // Check if user has any permission (edit, delete, view)
    const canEdit = checkPermission(loginUserData, "users", "edit");
    const canDelete = checkPermission(loginUserData, "users", "delete");
    const canView = checkPermission(loginUserData, "users", "view");

    // Remove "Actions" column if no permissions are granted
    if (!canEdit && !canDelete && !canView) {
      this.columns = this.columns.filter((item) => item.key !== "action");
    }

    // Keep existing state logic
    this.setState({
      isLoading: false,
      userSelectedData: null,
    });
  }

  modalRef;

  listCourseReviewData = async (start, end) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListCourseReviewData,
        setListCourseReviewDataTotaL,
        course_id,
      } = this.props;
      this.setState({
        isLoading: true,
      });

      let CourseReviewData = await getAllCourseReview(
        authToken,
        start,
        end,
        course_id
      );

      if (CourseReviewData.status === 200) {
        this.setState({
          data: CourseReviewData.data,
        });
        await setListCourseReviewData(CourseReviewData.data);
        await setListCourseReviewDataTotaL(CourseReviewData.total);
      } else if (CourseReviewData.status == 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      console.log("!!!!!!!list user Data printed here", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  async getLimitedCourseReview(pagination) {
    const { searchText } = this.props;
    console.log("tempCounter && counter --> ", this.tempCounter, this.counter);
    const start = (pagination.current - 1) * pagination.pageSize;
    const end = pagination.pageSize;

    this.setState(
      {
        isLoading: true,
        startIndex: start,
        limitNumber: end,
      },
      async () => {
        if (searchText != null && searchText !== "") {
          //get search text props from redux store
          this.listSearchFaqData(start, end);
        } else {
          //call normal user Data
          this.listCourseReviewData(start, end);
        }
      }
    );
  }

  counter = 0;
  tempCounter = 0;
  columns = [
    {
      title: "Sr. No.",
      width: 150,
      key: "serial_number",
      render: (text, item, index) => {
        return (
          <div>
            <span>{++index + this.tempCounter}</span>
          </div>
        );
      },
    },
    {
      title: "Name",
      width: 150,
      key: "user_name",
      render: (text, item, index) => {
        console.log("user record --> ", item);
        return (
          <div>
            <strong>
              <Tooltip placement="bottom" title="Question">
                <div>
                  {item.reviewUserData && item.reviewUserData.length > 0
                    ? (item.reviewUserData[0].first_name || "") +
                      " " +
                      (item.reviewUserData[0].last_name || "")
                    : "-"}
                </div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Star",
      width: 150,
      key: "star",
      render: (text, item, index) => {
        console.log("user record --> ", item);
        return (
          <div>
            <strong>
              <Tooltip
                placement="bottom"
                title={item && item.ratings ? item.ratings : "-"}
              >
                <div>
                  <Rate
                    disabled
                    defaultValue={item && item.ratings ? item.ratings : "-"}
                    style={{ fontSize: "14px" }}
                  />
                </div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Comments",
      width: 150,
      key: "comments",
      render: (text, item, index) => {
        console.log("user record --> ", item);
        return (
          <div>
            <strong>
              <Tooltip
                placement="bottom"
                title={item.review ? item.review : "-"}
              >
                <div>{item.review ? item.review : "-"}</div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Posted Date",
      width: 150,
      key: "user_name",
      render: (text, item, index) => {
        console.log("user record --> ", item);
        return (
          <div>
            <strong>
              <Tooltip
                placement="bottom"
                title={
                  item.createdAt
                    ? moment(item.createdAt).format("DD MMM YYYY")
                    : "-"
                }
              >
                <div>
                  {item.createdAt
                    ? moment(item.createdAt).format("DD MMM YYYY")
                    : "-"}
                </div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
  ];

  handleTableChange(pagination, filters) {
    console.log("outer onchange iusers", pagination);
    this.setState(
      {
        pagination,
      },
      () => this.getLimitedCourseReview(pagination)
    );
  }

  render() {
    const { isLoading, data } = this.state;
    const { listCourseReviewData, listFaqDataTotal, searchLoader } = this.props;

    return isLoading || searchLoader ? (
      <div style={{ marginLeft: "20px" }}>
        <Spin
          size="large"
          style={{ marginLeft: "480px", marginTop: "130px" }}
        />
      </div>
    ) : (
      <div style={{ overflowX: "auto" }}>
        <Table
          loading={this.state.isLoading}
          rowKey={(record) => record._id}
          columns={this.columns}
          size={"small"}
          // dataSource={this.state.data}
          dataSource={listCourseReviewData}
          pagination={{
            total: this.props.listCourseReviewDataTotal,
            showSizeChanger: true,
            pageSize: this.state.pagination.pageSize,
            current: this.state.pagination.current,
            pageSizeOptions: ["1", "10", "25", "50", "100"],
            selectComponentClass: NativeSelect,
            onChange: (page, pageSize) => {
              console.log("Page change:", page, "Page size:", pageSize);

              this.setState(
                {
                  pagination: {
                    ...this.state.pagination,
                    current: page,
                    pageSize: pageSize,
                  },
                },
                () => {
                  this.getLimitedCourseReview({
                    current: page,
                    pageSize: pageSize,
                  });
                }
              );
            },
            onShowSizeChange: (current, size) => {
              this.setState(
                {
                  pagination: {
                    ...this.state.pagination,
                    current: 1, // Reset to first page when changing size
                    pageSize: size,
                  },
                },
                () => {
                  this.getLimitedCourseReview({
                    current: 1,
                    pageSize: size,
                  });
                }
              );
            },
          }}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  listCourseReviewData: state.courseReview.listCourseReviewData,
    listCourseReviewDataTotal: state.courseReview.listCourseReviewDataTotal,
  searchLoader: state.auth.searchLoader,
  searchText: state.auth.searchText,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginFlag: (flag) => {
      dispatch({
        type: "SET_LOGIN_FLAG",
        flag: flag,
      });
    },
    setUserData: (userData) => {
      dispatch({
        type: "SET_USER_DATA",
        userData: userData,
      });
    },
    setUserToken: (authToken) => {
      dispatch({
        type: "SET_USER_AUTHTOKEN",
        authToken: authToken,
      });
    },
    setListCourseReviewData: (listCourseReviewData) => {
      dispatch({
        type: "SET_LIST_COURSE_REVIEW_DATA",
        listCourseReviewData: listCourseReviewData,
      });
    },
    setListCourseReviewDataTotal: (listCourseReviewDataTotal) => {
      dispatch({
        type: "SET_LIST_COURSE_REVIEW_DATA_TOTAL",
        listCourseReviewDataTotal: listCourseReviewDataTotal,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CourseReviewRecordsTable));
